import type { RootState } from 'app/store/root/root.state';
import type { Uuid } from 'shared/common/types';
import { createSelector } from '@ngrx/store';
import { selectRootState } from 'app/store/root/root.state';
import * as fromWebhooks from './webhooks.reducer';

export const webhooksState = createSelector(
  selectRootState,
  state => state.webhooks,
);

export const webhooks = createSelector(
  selectRootState,
  state => fromWebhooks.selectAll(state.webhooks),
);

export const oneWebhook = createSelector(
  selectRootState,
  (state: RootState, props: { id: Uuid }) => fromWebhooks.selectEntities(state.webhooks)[props.id],
);

export const events = createSelector(
  selectRootState,
  state => state.webhooks.events,
);
